<template>
  <md-card>
    <md-card-header>
      <h3>Datos de contacto</h3>
    </md-card-header>

    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100 md-xsmall-size-100">
          <div class="md-layout-item md-size-100 md-small-size-100">
            <md-field
              :class="[
                {
                  'md-valid':
                    !errors.has('contactData.contact') && touched.contact,
                },
                { 'md-form-group': true },
                { 'md-error': errors.has('contactData.contact') },
              ]"
            >
              <md-icon>face</md-icon>
              <label>Contacto</label>
              <md-input
                v-model="contactData.contact"
                data-vv-name="contactData.contact"
                type="text"
                name="contact"
                required
                v-validate="modelValidations.contact"
              ></md-input>
              <slide-y-down-transition>
                <md-icon
                  class="error"
                  v-show="errors.has('contactData.contact')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('contactData.contact') && touched.contact"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
          </div>
        </div>

        <div class="md-layout-item md-size-50 md-xsmall-size-100">
          <md-field
            :class="[
              { 'md-valid': !errors.has('contactData.phone') && touched.phone },
              { 'md-form-group': true },
              { 'md-error': errors.has('contactData.phone') },
            ]"
          >
            <md-icon>phone</md-icon>
            <label>Teléfono (10 dígitos)</label>
            <md-input
              type="text"
              name="phone"
              v-model="contactData.phone"
              data-vv-name="contactData.phone"
              required
              v-validate="modelValidations.phone"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('contactData.phone')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('contactData.phone') && touched.phone"
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
        </div>

        <div class="md-layout-item md-size-33 md-xsmall-size-100">
          <md-field
            :class="[
              {
                'md-valid':
                  !errors.has('contactData.phoneExt') && touched.phoneExt,
              },
              { 'md-form-group': true },
              { 'md-error': errors.has('contactData.phoneExt') },
            ]"
          >
            <md-icon>phone</md-icon>
            <label>Extensión</label>
            <md-input
              required
              type="text"
              name="phoneExt"
              v-model="contactData.phoneExt"
              data-vv-name="contactData.phoneExt"
              v-validate="modelValidations.phoneExt"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('contactData.phoneExt')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('contactData.phoneExt') && touched.phoneExt"
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-xsmall-size-100">
          <md-field
            :class="[
              {
                'md-valid':
                  !errors.has('contactData.cellphone') && touched.cellphone,
              },
              { 'md-form-group': true },
              { 'md-error': errors.has('contactData.cellphone') },
            ]"
          >
            <md-icon>smartphone</md-icon>
            <label>Teléfono Móvil (10 dígitos)</label>
            <md-input
              v-model="contactData.cellphone"
              data-vv-name="contactData.cellphone"
              type="text"
              name="cellphone"
              required
              v-validate="modelValidations.cellphone"
            ></md-input>
            <slide-y-down-transition>
              <md-icon
                class="error"
                v-show="errors.has('contactData.cellphone')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="
                  !errors.has('contactData.cellphone') && touched.cellphone
                "
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50 md-xsmall-size-100">
          <md-field
            :class="[
              {
                'md-valid':
                  !errors.has('contactData.alternativeEmail') &&
                  touched.alternativeEmail,
              },
              { 'md-form-group': true },
              { 'md-error': errors.has('contactData.alternativeEmail') },
            ]"
          >
            <md-icon>mail</md-icon>
            <label>Correo electrónico</label>
            <md-input
              required
              type="text"
              name="alternativeEmail"
              v-model="contactData.alternativeEmail"
              data-vv-name="contactData.alternativeEmail"
              v-validate="modelValidations.alternativeEmail"
            ></md-input>
            <slide-y-down-transition>
              <md-icon
                class="error"
                v-show="errors.has('contactData.alternativeEmail')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="
                  !errors.has('contactData.alternativeEmail') &&
                  touched.alternativeEmail
                "
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <contact-address
          @setAsentamiento="(v) => $emit('setAsentamiento', v)"
          :address="contactData.address"
          :modify="modify"
        ></contact-address>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import ContactAddress from "./Address";
import { SlideYDownTransition } from "vue2-transitions";
import usesParentValidatorMixin from "@/mixins/usesParentValidator";

const modelValidations = {
  contact: {
    required: true,
    min: 5,
  },
  phone: {
    numeric: true,
    length: 10,
  },
  phoneExt: {
    numeric: true,
  },
  cellphone: {
    numeric: true,
    length: 10,
  },
  address: {},
  alternativeEmail: {
    email: true,
  },
};

const touched = {
  phone: false,
  phoneExt: false,
  cellphone: false,
  alternativeEmail: false,
  contact: false,
};

export default {
  name: "ContactData",
  mixins: [usesParentValidatorMixin],
  components: { ContactAddress, SlideYDownTransition },
  props: {
    contactData: {
      type: Object,
      default: () => ({}),
    },
    modify: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.watchTouched({ contactData: Object.keys(modelValidations) });
  },
  data() {
    return {
      modelValidations,
      touched,
    };
  },
  watch: {
    "contactData.phone": function () {
      this.touched.phone = true;
    },
    "contactData.phoneExt": function () {
      this.touched.phoneExt = true;
    },
    "contactData.cellphone": function () {
      this.touched.cellphone = true;
    },
    "contactData.alternativeEmail": function () {
      this.touched.alternativeEmail = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Providers/wizard/ContactData.vue